import React from "react";
import { MDBRow, MDBBox, MDBCol, MDBContainer } from "mdbreact";

import {
  LeadingTheWayImage,
  LeadingTheWayText,
} from "./leading-the-way-query-container";
const LeadingTheWay = () => {
  return (
    <MDBContainer fluid className="leading-the-way">
      <MDBRow className="leading-inner">
        <MDBCol className="leading-text" lg="4">
          <LeadingTheWayText />
        </MDBCol>
        <MDBCol className="leading-image" lg="6">
          <LeadingTheWayImage />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default LeadingTheWay;
